import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Listing from "@/pages/Listing";
import EntityDetail from "@/pages/EntityDetail";
import Search from "@/pages/Search";
import Auth from "@/pages/Auth";
import MyAccount from "@/pages/MyAccount";
import Admin from "@/pages/Admin";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import { LangProvider } from "@/context/LangContext";
import BookingCheckout from "@/pages/BookingCheckout";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/dhams" element={<Listing type="dham" title="Dhams" />} />
            <Route path="/temples" element={<Listing type="temple" title="Temples" />} />
            <Route path="/yatras" element={<Listing type="yatra" title="Yatra Circuits" />} />
            <Route path="/hotels" element={<Listing type="hotel" title="Hotels" />} />
            <Route path="/dharamshalas" element={<Listing type="dharamshala" title="Dharamshalas" />} />
            <Route path="/packages" element={<Listing type="package" title="Tour Packages" />} />
            <Route path="/search" element={<Search />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/guides/:slug" element={<GuideDetail />} />
            <Route path="/e/:slug" element={<EntityDetail />} />
            <Route path="/checkout/:slug" element={<BookingCheckout />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/account" element={<MyAccount />} />
            <Route path="/admin/*" element={<Admin />} />
          </Route>
        </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <LangProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRouter />
      </BrowserRouter>
      </LangProvider>
    </AuthProvider>
  );
}

export default App;
